import { Box, Button } from "@mui/material";
import { IRateAppointment } from "../interface/iRateAppointment";
import { RateAppointmentContext } from "../context/rateAppointmentContext";
import React from "react";

const SubmitRatingButton = (): React.JSX.Element => {
  const {
    rateAppointmentDto,
    isLoading,
    handleSubmit,
  }: {
    rateAppointmentDto: IRateAppointment;
    isLoading: boolean;
    handleSubmit: () => void;
  } = React.useContext(RateAppointmentContext);

  // This function checks if all star questions have been rated
  const checkFormValidity = (): boolean =>
    rateAppointmentDto.starQestions.every((question) => question.rating !== 0);

  return (
    <Box sx={{ pt: 6 }}>
      <Button
        disabled={!checkFormValidity() || isLoading}
        variant="contained"
        color="secondary"
        size="large"
        sx={{ mt: 2, mb: 2, width: { xs: "100%", sm: "auto" } }}
        onClick={handleSubmit}
      >
        {isLoading ? "Bewertung wird gesendet..." : "Bewertung abschicken"}
      </Button>
    </Box>
  );
};

export default SubmitRatingButton;
